import Vue from 'vue';

function getPreviewEl (el) {
    const previewElClass = 'v-md-editor-preview';

    return el.classList.contains(previewElClass) ? el : el.querySelector(`.${previewElClass}`);
}

/**
 * 截取URL，去掉前面的域名
 */
function parseUrl (url) {
    if (url && url.indexOf('/hjmos-znjn-service/') >= 0) {
        url = '/hjmos-znjn-service/' + url.substring(url.indexOf('/hjmos-znjn-service/') + 20);
    }
    return url;
}

export default function createModelCOPPlugin () {
    async function handleMdChange () {
        if (typeof window === 'undefined') return;

        await this.$nextTick();

        const previewEl = getPreviewEl(this.$el);
        const eles = previewEl.querySelectorAll('.v-md-pre-wrapper-gpt-chatbox-cop');
        if (!eles.length) return;

        let ele = eles[0];
        if (!ele || !ele.innerText) return;

        try {
            let text = ele.innerText;
            ele.innerText = '';

            console.info('智能节能：', text);

            // 管控平台Socket返回的json
            let nccJson = JSON.parse(text);

            let url = parseUrl(nccJson.url);
            let resp = await fetch(url);
            let json = await resp.json();

            if (!json || !json.data) {
                ele.innerText = '未识别数据';
                return;
            }

            let compName = null;
            let data = null;
            let tableData = json.data['chart-table'];
            let lineData = json.data['chart-line'];
            let barData = json.data['chart-bar'];
            let pieData = json.data['chart-pie'];
            if (tableData && tableData.length) {
                // 表格
                data = tableData;
                compName = 'gpt-chart-table';
            } else if (lineData && lineData.length) {
                // 折线图
                data = lineData;
                compName = 'gpt-chart-line';
            } else if (barData && barData.length) {
                // 柱状图
                data = barData;
                compName = 'gpt-chart-bar';
            } else if (pieData && pieData.length) {
                // 饼图
                data = pieData;
                compName = 'gpt-chart-pie';
            }

            if (data && compName) {
                let propsData = { value: data };// 组件初始化时传入绑定数据（propsData只能用于初始化，复发响应式）

                let Comp = Vue.component(compName);
                if (!Comp) {
                    throw new Error(`Component ${compName} not found`);
                }
                let comp = new Comp({ propsData });
                comp.$mount(ele);
            } else {
                ele.innerText = '未识别数据';
            }
        } catch (err) {
            console.error(err);
            ele.innerText = '分析过程中出现错误';
        }
    }

    return {
        install (VMdEditor) {
            if (!VMdEditor.mixins) VMdEditor.mixins = [];

            VMdEditor.mixins.push({
                watch: {
                    value: {
                        immediate: true,
                        handler: handleMdChange
                    },
                    text: {
                        immediate: true,
                        handler: handleMdChange
                    },
                    currentMode: handleMdChange
                }
            });
        }
    };
};
